import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/logistics/orders/new")({
  beforeLoad: () => {
    throw redirect({
      to: "/logistics/orders/$id/edit",
      params: { id: "new" },
    });
  },
});
